import { Component, Input, OnChanges } from "@angular/core";
import { UnitConversionService, UnitConversionType } from "@services/unitConversion.service";

@Component({
    selector: 'unit-conversion-suffix',
    template: '{{outputValue}}'
})
export class UnitConversionSuffixComponent implements OnChanges {

    @Input() distance: boolean;
    @Input() speed: boolean;
    @Input() fuel: boolean;
    @Input() temperature: boolean;
    @Input() capacity: boolean;
    @Input() currency: boolean;

    @Input() conversionType: UnitConversionType;
    @Input() value: number;

    // ---

    outputValue: string;
    conversion: string;

    constructor(private unitConversionService: UnitConversionService) {
    }

    ngOnChanges() {
        this.checkAndSetConversionType();
        this.createUOMString();
        this.setOutputValue();
    }

    private checkAndSetConversionType() {
        if (this.conversionType != null) {
            return;
        }

        this.conversionType = UnitConversionType.Distance;

        if (this.speed) {
            this.conversionType = UnitConversionType.Speed;
        }
        else if (this.fuel) {
            this.conversionType = UnitConversionType.FuelEfficiency;
        }
        else if (this.capacity) {
            this.conversionType = UnitConversionType.FuelCapacity;
        }
        else if (this.temperature) {
            this.conversionType = UnitConversionType.Temperature;
        }
        else if (this.currency) {
            this.conversionType = UnitConversionType.Currency;
        }
    }

    private setOutputValue() {
        if (this.value === undefined) {
            this.outputValue = this.conversion;
            return;
        }

        var valueString = this.value ? this.value.toLocaleString() : "";

        if (this.conversionType == UnitConversionType.Currency) {

            this.outputValue = this.conversion + valueString;
        }
        else {
            this.outputValue = valueString + " " + this.conversion;
        }
    }

    private createUOMString() {
        this.conversion = this.unitConversionService.getConversionLabel(this.conversionType);
    }
}
